import { MSSK } from './configs/dictionaryClassifiers';

function setTrees(arr) {
  let trees = [];
  let treeCounter = -1;

  arr.forEach((item) => {
    if (item.parentCode === null) {
      treeCounter += 1;
      trees[treeCounter] = [];

      item.parentId = null;
      item.position = treeCounter;
    }
    trees[treeCounter].push(item);
  });

  return trees;
}

function convertToDbType(type, num) {
  let newType = '';

  switch (type) {
    case 'Текстовый':
    case 'Дата':
    case 'Ссылка':
      newType = 'text';
      break;
    case 'Числовой':
      newType = 'numeric';
      break;
    case 'Из списка':
      newType = 'list';
      break;
    case 'Логический':
      newType = 'logical';
      break;
    default:
      throw new Error(`Unknown CHARACTERISTIC_TYPE: ${type} in ${num}`);
  }

  return newType;
}

export function convertDataFromMssk(rowData, tableCode, isFeature) {
  let arr = [];

  // 1-st pass to set initial properties
  for (let i = 0; i < rowData.length; i++) {
    let obj = {};
    let descr = [];

    obj.code = rowData[i].code;
    obj.classifierId = rowData[i].classifierId;
    obj.classifierTableId = rowData[i].classifierTableId;
    Object.keys(rowData[i]).forEach((key) => {
      if (key.indexOf('level') === 0) {
        if (rowData[i][key]) {
          obj.level = +key.split('_')[1];
          obj.name = rowData[i][key];
          if (obj.level === 1) {
            obj.parentCode = null;
          } else {
            if (arr[i - 1].level === obj.level) {
              obj.parentCode = arr[i - 1].parentCode;
            } else {
              if (arr[i - 1].level < obj.level) {
                obj.parentCode = arr[i - 1].code;
              } else {
                for (let j = i - 1; j >= 0; j--) {
                  if (arr[j - 1].level < obj.level) {
                    obj.parentCode = arr[j - 1].code;
                    break;
                  }
                }
              }
            }
          }
        }
      }

      if (key.indexOf('param') === 0) {
        if (rowData[i][key] !== null) {
          descr.push(`${MSSK[tableCode.toLowerCase()][+key.split('_')[1] - 1]}: ${rowData[i][key]}`);
        }
      }

      if (key.indexOf('IFC') === 0) obj.ifc = setIfcValue(rowData[i][key]);
    });

    if (descr.length) {
      obj.description = descr.join(', ');
    }

    arr.push(obj);
  }

  // 2-nd pass to set node as terminal and features
  setAsTerminalAndFeature(arr, isFeature, false);

  return setTrees(arr);
}

export function convertDataFromKsi(rowData) {
  // 1. Create levels object
  let innerLevels = [];
  let ksiFileKeys = {};

  Object.keys(rowData[0]).forEach((key) => {
    if (key.trim().indexOf('Класс') === 0) {
      ksiFileKeys[key] = 1;
    }
    if (key.trim().indexOf('Подкласс') === 0) {
      innerLevels.push(key);
    }
    if (key.trim().indexOf('Тип') === 0) {
      ksiFileKeys.type = key;
    }
  });
  if (innerLevels.length) {
    innerLevels.sort((a, b) => {
      let aInner = a.trim().split(' ')[1] ? +a.trim().split(' ')[1] : 0;
      let bInner = b.trim().split(' ')[1] ? +b.trim().split(' ')[1] : 0;

      return aInner - bInner;
    });
    innerLevels.forEach((item, k) => {
      ksiFileKeys[item] = k + 2;
    });
  }
  ksiFileKeys[ksiFileKeys.type] = innerLevels.length + 2;
  delete ksiFileKeys.type;

  // 2. Prepare array with modify data
  let arr = prepareArrayWithModifyData(rowData, ksiFileKeys);

  // ----------- 2.2. Set parent code  -----------------------------
  setParentCode(arr, false);

  // One more pass to set node as terminal and features
  setAsTerminalAndFeature(arr, false, true);

  return setTrees(arr);
}

export function convertDataFromKsiFeatures(rowData) {
  let arr = [];
  let levelsObj = {};
  let name;
  let level;

  // ----------- 1. Set properties except parentCode -------------
  rowData.forEach((item) => {
    let links = {};
    if (item.par_1.trim().length > 0) {
      links['МССК'] = item.par_1
        .split('\n')
        .map((item) => item.trim())
        .filter((i) => i.trim().length > 0);
    }
    Object.keys(item).forEach((key) => {
      if (key.indexOf('lev_') !== -1) {
        if (item[key]) {
          name = item[key];
          level = +key.split('_')[1];
        }
      }
    });
    arr.push({
      code: item.code,
      name: name,
      description: item.def,
      level: level,
      classifierId: item.classifierId,
      classifierTableId: item.classifierTableId,
      source: item.source,
      links: links,
      type: item.type,
      list: item.list,
      // ksi: item.sect,
      // ksiSections: item.sect_parts,
      ksi_uin: item.ksi_uin || '',
    });
  });

  // ----------- 2. Set levels    --------------------------------
  arr.forEach((item) => {
    if (!(item.level in levelsObj)) levelsObj[item.level] = [];
    levelsObj[item.level].push(item);
  });

  // ----------- 3. Set parent code  -----------------------------
  setParentCode(arr, true, levelsObj);

  // One more pass to set node as terminal and features
  setAsTerminalAndFeature(arr, true, true);

  return setTrees(arr);
}

function setIfcValue(item) {
  return item
    ? item.split(', ').map(function (item) {
        return {
          attribute_code: '',
          class_code: item,
          ifc_code: '4.3',
          value_sets: [],
        };
      })
    : [];
}

function setParentCode(arr, isFeature, levelsObj = {}) {
  arr.forEach((item, i) => {
    if (item.level === 1) {
      item.parentCode = null;
    } else if (isFeature) {
      let levelNum;

      if (item.level === 5) {
        if (item.code.indexOf('_') === -1) {
          levelNum = 4;
        } else {
          levelNum = 4 - (item.code.slice(0, -4).length - item.code.indexOf('_'));
        }
      } else {
        levelNum = item.level - 1;
      }
      levelsObj[levelNum].forEach((parentItem) => {
        let cleanedParentCode = parentItem.code.split('_')[0];

        if (item.code.indexOf(cleanedParentCode) === 0) {
          item.parentCode = parentItem.code;
        }
      });
    } else {
      if (item.level === arr[i - 1].level) {
        item.parentCode = arr[i - 1].parentCode;
      } else {
        if (item.level > arr[i - 1].level) {
          item.parentCode = arr[i - 1].code;
        } else {
          for (let j = i - 1; j >= 0; j--) {
            if (item.level > arr[j].level) {
              item.parentCode = arr[j].code;
              break;
            }
          }
        }
      }
    }
  });
}

function prepareArrayWithModifyData(rowData, ksiFileKeys) {
  let arr = [];

  // ----------- Set properties except parentCode -------------
  rowData.forEach((item) => {
    let code;
    let name;
    let description;
    let level;
    let source = null;
    let ifc = [];
    let ksi_uin = '';
    let links = {};

    Object.keys(item).forEach((key) => {
      if (key.trim().indexOf('Наименование') === 0) name = item[key];
      if (key.trim().indexOf('Определение') === 0) description = item[key];
      if (key.trim().indexOf('Источник') === 0) source = item[key];

      if (key in ksiFileKeys && item[key]) {
        code = item[key];
        level = ksiFileKeys[key];
      }
      if (key.trim().indexOf('IFC') === 0) ifc = setIfcValue(item[key]);
      if (key.trim().indexOf('УИН') === 0) ksi_uin = item[key];

      if (key.includes('МССК') && !key.includes('Синонимы')) {
        links['МССК'] = item[key]
          .split('\n')
          .map((item) => item.trim())
          .filter((i) => i.trim().length > 0);
      }
    });
    arr.push({
      code: code,
      name: name,
      description: description,
      level: level,
      classifierId: item.classifierId,
      classifierTableId: item.classifierTableId,
      source: source,
      ifc: ifc,
      ksi_uin: ksi_uin,
      links: links,
    });
  });

  return arr;
}

function setAsTerminalAndFeature(arr, isFeature, isKsi) {
  arr.forEach((item, k) => {
    let index = arr.findIndex((i) => i.parentCode === item.code);

    if (index === -1) {
      item.terminalNode = true;

      if (isFeature) {
        item.characteristic = true;
        item.characteristicType = item.type && isKsi ? convertToDbType(item.type.trim(), k) : 'text';
        if (isKsi) item.characteristicValues = item.list ? item.list.split('\n').map((i) => i.trim()) : item.list;

        if (isKsi && 'type' in item) delete item.type;
        if (isKsi && 'list' in item) delete item.list;
      }
    }
  });
}
